import { createFileRoute } from '@tanstack/react-router';

import Page from '@/screens/chat/projects/detail/page';

export const Route = createFileRoute('/_app/_chat/projects/$projectId/')({
  component: Page,
});
